
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Mail, User } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';
import { formSchema } from '@/utils/contactFormUtils';

interface PersonalDetailsFieldsProps {
  form: UseFormReturn<z.infer<typeof formSchema>>;
}

const PersonalDetailsFields: React.FC<PersonalDetailsFieldsProps> = ({ form }) => {
  const isMobile = useIsMobile();

  return (
    <div className={`space-y-3 ${isMobile ? 'p-4' : 'p-6'} bg-white rounded-lg border border-elegant-200 backdrop-blur-sm shadow-lg`}>
      <h3 className="text-xl font-serif text-elegant-900 pb-2 border-b border-elegant-200 text-left">Dane kontaktowe</h3>
      
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormItem className="space-y-1">
            <FormLabel className={`text-${isMobile ? 'xs' : 'sm'} font-inter text-left block text-elegant-700 tracking-wider font-light uppercase`}>WASZE IMIONA</FormLabel>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-elegant-400">
                <User className="h-4 w-4" />
              </div>
              <FormControl>
                <Input 
                  placeholder="Tutaj wpiszcie Wasze imiona" 
                  {...field} 
                  className={`pl-10 ${isMobile ? 'py-1.5 text-sm' : 'py-2'} rounded bg-white border-elegant-200 text-elegant-900 placeholder:text-elegant-400 focus:ring-0 focus:border-elegant-300 focus:ring-elegant-300 shadow-inner shadow-elegant-100/20`} 
                />
              </FormControl>
            </div>
            <FormMessage className="text-red-500 text-xs" />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="email"
        render={({ field }) => (
          <FormItem className="space-y-1">
            <FormLabel className={`text-${isMobile ? 'xs' : 'sm'} font-inter text-left block text-elegant-700 tracking-wider font-light uppercase`}>EMAIL</FormLabel>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none text-elegant-400">
                <Mail className="h-4 w-4" />
              </div>
              <FormControl>
                <Input 
                  placeholder="wasz@email.com" 
                  {...field} 
                  className={`pl-10 ${isMobile ? 'py-1.5 text-sm' : 'py-2'} rounded bg-white border-elegant-200 text-elegant-900 placeholder:text-elegant-400 focus:ring-0 focus:border-elegant-300 focus:ring-elegant-300 shadow-inner shadow-elegant-100/20`} 
                />
              </FormControl>
            </div>
            <FormMessage className="text-red-500 text-xs" />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="message"
        render={({ field }) => (
          <FormItem className="space-y-1">
            <FormLabel className={`text-${isMobile ? 'xs' : 'sm'} font-inter text-left block text-elegant-700 tracking-wider font-light uppercase`}>TWOJA WIADOMOŚĆ</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Opisz swoje oczekiwania, pytania lub szczegóły dotyczące wydarzenia..." 
                {...field}
                rows={isMobile ? 3 : 4}
                className={`rounded ${isMobile ? 'text-sm' : ''} bg-white border-elegant-200 text-elegant-900 placeholder:text-elegant-400 focus:ring-0 focus:border-elegant-300 focus:ring-elegant-300 shadow-inner shadow-elegant-100/20`} 
              />
            </FormControl>
            <FormMessage className="text-red-500 text-xs" />
          </FormItem>
        )}
      />
    </div>
  );
};

export default PersonalDetailsFields;
